import { render, staticRenderFns } from "./ProfilesTable.vue?vue&type=template&id=52045463&scoped=true"
import script from "./ProfilesTable.vue?vue&type=script&lang=js"
export * from "./ProfilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52045463",
  null
  
)

export default component.exports